export default __webpack_public_path__ + "static/media/Class.0c69db07.svg";